import { combineReducers } from 'redux';
import {
  REPORTS_TRANSACTIONS_SET_TRANSACTIONS,
  REPORTS_TRANSACTIONS_SET_TRANSACTION_DETAIL,
  REPORTS_TRANSACTIONS_SHOW_RESEND_EMAIL_MODAL,
  REPORTS_TRANSACTIONS_HIDE_RESEND_EMAIL_MODAL,
  REPORTS_TRANSACTIONS_SHOW_REFUND_BREAKDOWN_MODAL,
  REPORTS_TRANSACTIONS_HIDE_REFUND_BREAKDOWN_MODAL,
  REPORTS_TRANSACTIONS_SHOW_TRANSACTION_DETAIL_MODAL,
  REPORTS_TRANSACTIONS_HIDE_TRANSACTION_DETAIL_MODAL,
  REPORTS_TRANSACTIONS_HIDE_OLD_REFUND_MODAL,
  REPORTS_TRANSACTIONS_SHOW_OLD_REFUND_MODAL,
  REPORTS_TRANSACTIONS_REFUND_BREAKDOWN_SET_REFUND_ITEMS,
  REPORTS_TRANSACTIONS_REFUND_BREAKDOWN_SET_REFUND_ITEMS_PROMO,
  REPORTS_TRANSACTIONS_SET_OUTLETS,
  REPORTS_TRANSACTIONS_HIDE_SET_QUANTITY_MODAL,
  REPORTS_TRANSACTIONS_SHOW_SET_QUANTITY_MODAL,
} from 'actions/reports/transactions/constants';
import createReducer from 'utils/createReducer';

const netSales = createReducer(0, {
  [REPORTS_TRANSACTIONS_SET_TRANSACTIONS]: (draft, { payload }) =>
    payload.transactions.netSales,
});

const openOldRefundModal = createReducer(false, {
  [REPORTS_TRANSACTIONS_SHOW_OLD_REFUND_MODAL]: () => true,
  [REPORTS_TRANSACTIONS_HIDE_OLD_REFUND_MODAL]: () => false,
});

const openRefundBreakdownModal = createReducer(false, {
  [REPORTS_TRANSACTIONS_SHOW_REFUND_BREAKDOWN_MODAL]: () => true,
  [REPORTS_TRANSACTIONS_HIDE_REFUND_BREAKDOWN_MODAL]: () => false,
});

const openResendEmailModal = createReducer(false, {
  [REPORTS_TRANSACTIONS_SHOW_RESEND_EMAIL_MODAL]: () => true,
  [REPORTS_TRANSACTIONS_HIDE_RESEND_EMAIL_MODAL]: () => false,
});

const openSetQuantityModal = createReducer(false, {
  [REPORTS_TRANSACTIONS_SHOW_SET_QUANTITY_MODAL]: () => true,
  [REPORTS_TRANSACTIONS_HIDE_SET_QUANTITY_MODAL]: () => false,
});

const openTransactionDetailModal = createReducer(false, {
  [REPORTS_TRANSACTIONS_SHOW_TRANSACTION_DETAIL_MODAL]: () => true,
  [REPORTS_TRANSACTIONS_HIDE_TRANSACTION_DETAIL_MODAL]: () => false,
});

const outlets = createReducer([], {
  [REPORTS_TRANSACTIONS_SET_OUTLETS]: (draft, { payload }) => payload.outlets,
});

const refundBreakdown = createReducer(
  {
    refundItems: [],
    refundItemsPromo: [],
  },
  {
    [REPORTS_TRANSACTIONS_REFUND_BREAKDOWN_SET_REFUND_ITEMS]: (
      draft,
      { payload }
    ) => {
      draft.refundItems = payload.items;
    },

    [REPORTS_TRANSACTIONS_REFUND_BREAKDOWN_SET_REFUND_ITEMS_PROMO]: (
      draft,
      { payload }
    ) => {
      draft.refundItemsPromo = payload.itemsPromo;
    },
  }
);

const totalCollected = createReducer(0, {
  [REPORTS_TRANSACTIONS_SET_TRANSACTIONS]: (draft, { payload }) =>
    payload.transactions.totalCollected,
});

const totalTransactions = createReducer(0, {
  [REPORTS_TRANSACTIONS_SET_TRANSACTIONS]: (draft, { payload }) =>
    payload.transactions.totalTransactions,
});

const transactionDetail = createReducer(null, {
  [REPORTS_TRANSACTIONS_SET_TRANSACTION_DETAIL]: (draft, { payload }) =>
    payload.transactionDetail,
});

const transactions = createReducer([], {
  [REPORTS_TRANSACTIONS_SET_TRANSACTIONS]: (draft, { payload }) =>
    payload.transactions.transactions,
});

const paymentMethods = createReducer([], {
  [REPORTS_TRANSACTIONS_SET_TRANSACTIONS]: (draft, { payload }) =>
    payload.transactions.paymentMethods,
});

export default combineReducers({
  netSales,
  openOldRefundModal,
  openRefundBreakdownModal,
  openResendEmailModal,
  openSetQuantityModal,
  openTransactionDetailModal,
  outlets,
  refundBreakdown,
  totalCollected,
  totalTransactions,
  transactionDetail,
  transactions,
  paymentMethods,
});
